function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
export default function withTooltip(BaseComponent, containerProps, renderContainer) {
  var _temp;

  if (containerProps === void 0) {
    containerProps = {
      style: {
        position: 'relative',
        width: 'inherit',
        height: 'inherit'
      }
    };
  }

  if (renderContainer === void 0) {
    renderContainer = function renderContainer(children, props) {
      return React.createElement("div", props, children);
    };
  }

  return _temp =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inheritsLoose(WrappedComponent, _React$PureComponent);

    function WrappedComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

      _defineProperty(_assertThisInitialized(_this), "state", {
        tooltipOpen: false,
        tooltipLeft: undefined,
        tooltipTop: undefined,
        tooltipData: undefined
      });

      _defineProperty(_assertThisInitialized(_this), "updateTooltip", function (_ref) {
        var tooltipOpen = _ref.tooltipOpen,
            tooltipLeft = _ref.tooltipLeft,
            tooltipTop = _ref.tooltipTop,
            tooltipData = _ref.tooltipData;

        _this.setState(function (prevState) {
          return _extends({}, prevState, {
            tooltipOpen: tooltipOpen,
            tooltipLeft: tooltipLeft,
            tooltipTop: tooltipTop,
            tooltipData: tooltipData
          });
        });
      });

      _defineProperty(_assertThisInitialized(_this), "showTooltip", function (_ref2) {
        var tooltipLeft = _ref2.tooltipLeft,
            tooltipTop = _ref2.tooltipTop,
            tooltipData = _ref2.tooltipData;

        _this.updateTooltip({
          tooltipOpen: true,
          tooltipLeft: tooltipLeft,
          tooltipTop: tooltipTop,
          tooltipData: tooltipData
        });
      });

      _defineProperty(_assertThisInitialized(_this), "hideTooltip", function () {
        _this.updateTooltip({
          tooltipOpen: false,
          tooltipLeft: undefined,
          tooltipTop: undefined,
          tooltipData: undefined
        });
      });

      return _this;
    }

    var _proto = WrappedComponent.prototype;

    _proto.render = function render() {
      return renderContainer(React.createElement(BaseComponent, _extends({
        updateTooltip: this.updateTooltip,
        showTooltip: this.showTooltip,
        hideTooltip: this.hideTooltip
      }, this.state, this.props)), containerProps);
    };

    return WrappedComponent;
  }(React.PureComponent), _temp;
}